import FingerprintJS from "@fingerprintjs/fingerprintjs";

class DeviceFingerprint {
  static #instance;

  static #getInstance() {
    if (!this.#instance) {
      this.#instance = FingerprintJS.load({
        monitoring: false,
        debug: process.env.NODE_ENV === "development",
      });
    }

    return this.#instance;
  }

  static async get() {
    // Should not happen This was part of Next.js Code, so keeping it for now for reference
    if (typeof window === "undefined") {
      throw new TypeError("NOT_IN_BROWSER");
    }

    const fp = await this.#getInstance();
    const result = await fp.get();

    const screenResolution = result.components.screenResolution?.value;

    return {
      visitorId: result.visitorId,
      confidenceScore: result.confidence?.score ?? 0,

      timezone:
        result.components.timezone?.value ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,

      screen: {
        resolution:
          screenResolution?.length === 2
            ? `${screenResolution[0]}x${screenResolution[1]}`
            : `${window.screen.width}x${window.screen.height}`,

        width: screenResolution?.[0] ?? window.screen.width,
        height: screenResolution?.[1] ?? window.screen.height,
      },

      platform: result.components.platform?.value || window.navigator.platform,
    };
  }
}

export default DeviceFingerprint;
